import { authComponents_svSE } from "@ssf/auth-components";
import { components_svSE, markdownToHtmlSync } from "@ssf/components";
import { memdbComponents_svSE } from "@ssf/memdb-components";
import i18next, { use } from "i18next";
import { merge } from "lodash";
import { initReactI18next } from "react-i18next";

import clubWeb_svSE from "../locales/locale.sv-SE.json";
import traditionalClubs_svSE from "../traditional-clubs/locales/locale.sv-SE.json";

const svSE = {
  ...merge(
    components_svSE,
    authComponents_svSE,
    memdbComponents_svSE,
    clubWeb_svSE,
  ),
  Questions: [...memdbComponents_svSE.Questions, ...clubWeb_svSE.Questions],
  TraditionalClubs: traditionalClubs_svSE,
};

const resources = {
  MemberForm: memdbComponents_svSE.MemberForm,
  issuesV2: memdbComponents_svSE.issuesV2,
  ...clubWeb_svSE,
  TraditionalClubs: traditionalClubs_svSE,
};

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "common";
    resources: typeof resources;
  }
}

use(initReactI18next)
  .use({
    type: "postProcessor",
    name: "markdown",
    process: (value: string) => markdownToHtmlSync(value),
  })
  .init({
    lng: "svSE",
    fallbackLng: "svSE",
    defaultNS: "common",
    resources: { svSE },
    react: {
      useSuspense: true,
      transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p",
        "em",
        "a",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "ul",
        "ol",
        "li",
      ],
    },
  });

export { i18next };
